<template>
  <v-select
    class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.id_unidade_regional"
    item-text="nomeRegiao"
    item-name="nomeRegiao"
    item-value="id_unidade_regional"
    :items="urs"
    label="Unidade Regional"
    placeholder="Unidade Regional"
    v-on:change="$emit('onChange')"
    :clearable="true"
  >
    <template slot="no-data"> Nenhuma UR retornado </template>
  </v-select>
</template>

<script>
import { urAPI } from "../../ur/API/urAPI";

export default {
  name: "ComboboxUnidadeRegional",
  props: ["filter"],
  mounted() {
    this.loadUrs();
  },
  methods: {
    loadUrs() {
      urAPI
        .list()
        .then((resp) => {
          this.urs = resp.data;
        })
        .catch();
    },
  },
  data() {
    return {
      urs: [],
    };
  },
};
</script>
